import { useAuth } from '../../app/AuthorizationProvider';
import {
  useGetShiftOverviewForShiftOfShiftSwapRequestLazyQuery,
  useGetSupervisorShiftOverviewForShiftSwapRequestLazyQuery,
} from '../../graphql/components';

import type { AgentShift, ShiftSwapRequestController } from '../../graphql/components';

type AgentBriefScheduleOverviewType = {
  isSupervisor?: boolean;
  onCompleted: (data: AgentShift) => void;
  variables: { userId: string; shiftSwapRequestId: string; controller: ShiftSwapRequestController };
};

export const useAgentBriefScheduleOverview = ({
  isSupervisor,
  onCompleted,
  variables: { controller, shiftSwapRequestId, userId },
}: AgentBriefScheduleOverviewType) => {
  const { userId: supervisorId } = useAuth();

  const [getUser, { loading: userLoading, data: userData }] = useGetShiftOverviewForShiftOfShiftSwapRequestLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data) {
        onCompleted(data.shiftOverviewForShiftFromShiftSwapRequest);
      }
    },
    variables: {
      controller,
      shiftSwapRequestId,
      userId,
    },
  });

  const [getSupervisor, { loading: supervisorLoading, data: supervisorData }] =
    useGetSupervisorShiftOverviewForShiftSwapRequestLazyQuery({
      fetchPolicy: 'network-only',
      onCompleted: (data) => {
        if (data) {
          onCompleted(data.supervisorShiftOverviewForShiftSwapRequest);
        }
      },
      variables: {
        controller,
        shiftSwapRequestId,
        supervisorId,
        userId,
      },
    });

  return [
    isSupervisor ? getSupervisor : getUser,
    {
      data: isSupervisor
        ? supervisorData?.supervisorShiftOverviewForShiftSwapRequest
        : userData?.shiftOverviewForShiftFromShiftSwapRequest,
      loading: userLoading || supervisorLoading,
    },
  ] as const;
};
